import { z } from '@harvestiq/zod';
import { dbAppSettingsUpdateSchema } from '../app-settings/db-app-settings';
import { orgAppSettingsSchema } from '../org-app-settings/org-app-settings';

// Make a partial update schema from the base schema, excluding read-only fields
export const updateSettingsRequestSchema = dbAppSettingsUpdateSchema;
export type UpdateSettingsRequest = z.infer<typeof updateSettingsRequestSchema>;

export const updateSettingsResponseSchema = z
  .object({
    data: orgAppSettingsSchema,
  })
  .or(z.object({ errors: z.object({ message: z.string() }).array() }));
export type UpdateSettingsResponse = z.infer<
  typeof updateSettingsResponseSchema
>;
